<script setup lang="ts">
import { useAddressBookStore } from '@/store/addressBook';
import { storeToRefs } from 'pinia';
import AddressBookAddressesTable from './AddressBookAddressesTable.vue';

const store = useAddressBookStore();
const { editBundle } = storeToRefs(store);

function save() {
  store.closeBundleDialog();
  store.saveEditBundle();
}
</script>

<template>
  <v-dialog v-model="store.bundleDialog" max-width="700px">
    <v-card>
      <v-card-text>
        <v-container>
          <h4>Bundle name</h4>
          <v-text-field
            v-model="editBundle.name"
            hide-details
            variant="solo-filled"
            density="compact"
            single-line
          ></v-text-field>
          <v-divider class="my-6"></v-divider>
          <AddressBookAddressesTable
            mode="editBundle"
            :bundle-id="editBundle.id"
          ></AddressBookAddressesTable>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          variant="text"
          @click="store.closeBundleDialog()"
          color="primary"
        >
          Cancel
        </v-btn>
        <v-btn
          :disabled="editBundle.items.length === 0"
          variant="text"
          @click="save()"
          color="primary"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
